import React, { Fragment } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';

const Button = props => {
    const {
        id,
        name,
        classes,
        outerClass,
        renderWithIconOnly = false,
        type,
        btnText,
        icon,
        iconSize,
        iconClassName,
        iconPlacement = 'END',
        path,
        handleClick,
        dataTestId,
        disabled = false,
        ariaLabel,
        ...rest
    } = props;

    const intl = useIntl();

    const clickHandle = () => {
        window.location.href = path;
    };

    const handleBtnClick = (e) => {
        handleClick(e);
    };

    const titleAttribute = renderWithIconOnly
        ? { title: intl.formatMessage({ id: btnText }) }
        : { };

    const textClassName = classnames(
        { 'usa-sr-only': renderWithIconOnly }
    );

    return (
        <Fragment>
            <div className={classnames(outerClass)}>
                <button
                    {...rest}
                    { ...titleAttribute }
                    type={type}
                    id={id}
                    data-testid={dataTestId || id}
                    name={name}
                    className={classnames('gi-button', classes)}
                    onClick= { path ? clickHandle : handleBtnClick }
                    aria-label={ariaLabel}
                    disabled={ disabled }
                >
                    { iconPlacement === 'START' && icon &&
                        <FontAwesomeIcon
                            icon={icon}
                            size={iconSize && iconSize}
                            className={classnames(iconClassName)}
                        />
                    }
                    <span className = { textClassName }>
                        <FormattedMessage id={btnText} />
                    </span>
                    { iconPlacement === 'END' && icon &&
                        <FontAwesomeIcon
                            icon={icon}
                            size={iconSize && iconSize}
                            className={classnames(iconClassName)}
                        />
                    }
                </button>
            </div>
        </Fragment>
    );

};

export default Button;